var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dialogs"},[_vm._l((_vm.dialogs),function(item){return [_c(item.tempModule,{key:item.name,tag:"component",staticClass:"dialog",on:{"onClose":_vm.onClose}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }